import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import logo from '../../Assets/logo.png';
import HCLogo from '../../Assets/HCLogo.png';
import comingSoon from '../../Assets/comingSoon.gif';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const HeaderBar = ({ AboutUsClicked, SpecClicked, LearnClicked, ContactUsClicked, isContactPage, onLogoClick }) => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const drawerRef = useRef(null);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setDrawerOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const headerStyle = isContactPage ? {
    backgroundColor: '#1A2933',
    color: 'white'
  } : {};

  const buttonStyle = isContactPage ? {
    color: 'white'
  } : {};

  return (
    <header className="header" style={headerStyle}>
      <div className="menu-icon" onClick={toggleDrawer} style={buttonStyle}>
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" strokeWidth="2" />
        </svg>
      </div>
      <div className={`drawer ${isDrawerOpen ? 'open' : ''}`} ref={drawerRef} style={headerStyle}>
        <nav className="drawer-nav">
          <div className="close-drawer" onClick={toggleDrawer} style={buttonStyle}>
            x
          </div>
          <img className="logo1" src={isContactPage ? HCLogo : logo} alt="Logo" />
          <div className="logo1-border"></div>
          <button className="nav-button" style={buttonStyle} onClick={() => {
            toggleDrawer();
            AboutUsClicked();
          }}>About</button>
          <button className="nav-button" style={buttonStyle} onClick={() => {
            toggleDrawer();
            SpecClicked();
          }}>Specs</button>
          <button className="nav-button" style={buttonStyle} onClick={() => {
            toggleDrawer();
            ContactUsClicked();
          }}>Contact Us</button>
          {/* <button className="learn-button-header" onClick={() => {
            toggleDrawer();
            LearnClicked();
          }}>Learn</button> */}

          {/* Using reactjs-popup for drawer Download button */}
          <Popup
            trigger={<button className="download-button-header">Download</button>}
            position="bottom center"
            closeOnDocumentClick
          >
            <div className="popup-content-1">
            <img src={comingSoon} alt="Coming soon" className="comingsoongif"/>
            </div>
          </Popup>
        </nav>
      </div>
      <img className="logo" src={isContactPage ? HCLogo : logo} alt="Logo" onClick={onLogoClick} style={{ cursor: 'pointer' }} />
      <nav className="nav-links">
        <button className="nav-button" style={buttonStyle} onClick={AboutUsClicked}>About</button>
        <button className="nav-button" style={buttonStyle} onClick={SpecClicked}>Specs</button>
        <button className="nav-button" style={buttonStyle} onClick={ContactUsClicked}>Contact Us</button>
        {/* <button className="learn-button-header" onClick={LearnClicked}>Learn</button> */}

        {/* Using reactjs-popup for Download button */}
        <Popup
            trigger={<button className="download-button-header">Download</button>}
            position="bottom center"
            closeOnDocumentClick
          >
            <div className="popup-content-1">
              <img src={comingSoon} alt="Coming soon" className="comingsoongif"/>
            </div>
          </Popup>
      </nav>
      {/* <div className="mobile">

      </div> */}
    </header>
  );
};

export default HeaderBar;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js